module.exports = "/images/instagram.svg?fafa422b6e3c7a8919c93bee6a1411fe";